import { createSlice } from "@reduxjs/toolkit";
import { loginAsync } from "./operations";
import { LoginState } from "./state";

const initialState: LoginState = {
  apps: {
    loadState: "Loading",
  },
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loginAsync.pending, (state) => {
      state.apps.loadState = "Loading";
    });
    builder.addCase(loginAsync.fulfilled, (state) => {
      state.apps.loadState = "Loaded";
    });
    builder.addCase(loginAsync.rejected, (state) => {
      state.apps.loadState = "LoadError";
    });
  },
});

export default loginSlice.reducer;
